<div class="container mt-4">

    <div class="card">
        <div class="card-header">
            <h5 class="card-title m-0">Feedback / Suggestions</h5>
        </div>
        <div class="card-body">
            <div class="card card-body">
                <p class="m-0">Thank you for taking the time to fill in our online feedback form. By providing us your
                    valuable feedback, you are helping us understand what we do well and what improvements we need to
                    implement.</p>
            </div>

            <form [formGroup]="feedbackForm">
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-2">
                        <label class="form-label">Name<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="name" placeholder="Enter your Name" />
                        <div *ngIf="feedbackForm.controls['name']?.invalid && feedbackForm.controls['name']?.touched"
                            class="text-danger">
                            Name is required.
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 mb-2">
                        <label class="form-label">Email<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="email"
                            placeholder="Enter your Email" />
                        <!-- <div
                              *ngIf="feedbackForm.controls['email']?.invalid && feedbackForm.controls['email']?.touched"
                              class="text-danger">
                              Email is required.
                        </div> -->
                        <div *ngIf="feedbackForm.controls['email'].invalid && feedbackForm.controls['email'].touched"
                            class="text-danger">
                            <small *ngIf="feedbackForm.controls['email'].errors?.['required']">Email is
                                required.</small>
                            <small *ngIf="feedbackForm.controls['email'].errors?.['email']">Invalid email
                                format.</small>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-6 mb-2">
                        <label class="form-label">Mobile No.<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="mobileNo" maxlength="10"
                            placeholder="Enter your Mobile No." (keypress)="allowOnlyNumbers($event)" />
                        <div *ngIf="feedbackForm.controls['mobileNo']?.invalid && feedbackForm.controls['mobileNo']?.touched"
                            class="text-danger">
                            Mobile number is required.
                        </div>
                    </div>

                    <div class="col-lg-12 mb-2">
                        <h6>How satisfied are you in terms of<span class="text-danger">*</span></h6>

                        <div class="table-responsive">
                            <table id="feedbackform" class="table table-condensed" style="margin-top: 2px">
                                <tbody>
                                    <tr style="background: #f6f6f6;">
                                        <td></td>
                                        <td style="text-align: center; width: 15%">Excellent</td>
                                        <td style="text-align: center; width: 15%">Good</td>
                                        <td style="text-align: center; width: 15%">Average</td>
                                        <td style="text-align: center; width: 15%">Not Satisfactory</td>
                                    </tr>

                                    <tr>
                                        <td style="text-align: left">Content and Information</td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="content" name="content"
                                                value="Excellent" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="content" name="content" value="Good" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="content" name="content"
                                                value="Average" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="content" name="content"
                                                value="Not Satisfactory" />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="text-align: left">Ease of Navigation</td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="easeOfNavigation"
                                                name="easeOfNavigation" value="Excellent" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="easeOfNavigation"
                                                name="easeOfNavigation" value="Good" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="easeOfNavigation"
                                                name="easeOfNavigation" value="Average" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="easeOfNavigation"
                                                name="easeOfNavigation" value="Not Satisfactory" />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="text-align: left">Information Process</td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="informationProcess"
                                                name="informationProcess" value="Excellent" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="informationProcess"
                                                name="informationProcess" value="Good" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="informationProcess"
                                                name="informationProcess" value="Average" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="informationProcess"
                                                name="informationProcess" value="Not Satisfactory" />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style="text-align: left">Accessibility</td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="accessibility" name="accessibility"
                                                value="Excellent" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="accessibility" name="accessibility"
                                                value="Good" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="accessibility" name="accessibility"
                                                value="Average" />
                                        </td>
                                        <td style="text-align: center">
                                            <input type="radio" formControlName="accessibility" name="accessibility"
                                                value="Not Satisfactory" />
                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>

                    </div>

                    <div class="col-lg-12 mb-2">
                        <div class="card card-body">
                            <p class="m-0">Please add any comments you have for improving the website. We welcome
                                suggestions on specific areas for improvements, features you would like to see added to
                                the site, and examples of what you consider good websites.</p>
                        </div>
                    </div>

                    <div class="col-lg-6 mb-2">
                        <label class="form-label">Message<span class="text-danger">*</span></label>
                        <textarea class="form-control" rows="4" formControlName="message"
                            placeholder="Enter your Comments"></textarea>
                        <div *ngIf="feedbackForm.controls['message']?.invalid && feedbackForm.controls['message']?.touched"
                            class="text-danger">
                            Message is required.
                        </div>
                    </div>

                    <!-- <div class="col-lg-6 mb-2">
                        <div class="mb-2">
                            <label class="form-label mb-0">How would you rate this website?<span
                                    class="text-danger">*</span></label>
                            <div id="half-stars-example">
                                <div class="rating-group">
                                    <input class="rating__input rating__input--none" checked name="rating2"
                                        id="rating2-0" value="0" type="radio">
                                    <label aria-label="0 stars" class="rating__label" for="rating2-0">&nbsp;</label>
                                    <label aria-label="0.5 stars" class="rating__label rating__label--half"
                                        for="rating2-05"><i
                                            class="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-05" value="0.5"
                                        type="radio">
                                    <label aria-label="1 star" class="rating__label" for="rating2-10"><i
                                            class="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-10" value="1" type="radio">
                                    <label aria-label="1.5 stars" class="rating__label rating__label--half"
                                        for="rating2-15"><i
                                            class="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-15" value="1.5"
                                        type="radio">
                                    <label aria-label="2 stars" class="rating__label" for="rating2-20"><i
                                            class="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-20" value="2" type="radio">
                                    <label aria-label="2.5 stars" class="rating__label rating__label--half"
                                        for="rating2-25"><i
                                            class="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-25" value="2.5" type="radio"
                                        checked>
                                    <label aria-label="3 stars" class="rating__label" for="rating2-30"><i
                                            class="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-30" value="3" type="radio">
                                    <label aria-label="3.5 stars" class="rating__label rating__label--half"
                                        for="rating2-35"><i
                                            class="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-35" value="3.5"
                                        type="radio">
                                    <label aria-label="4 stars" class="rating__label" for="rating2-40"><i
                                            class="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-40" value="4" type="radio">
                                    <label aria-label="4.5 stars" class="rating__label rating__label--half"
                                        for="rating2-45"><i
                                            class="rating__icon rating__icon--star fa fa-star-half"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-45" value="4.5"
                                        type="radio">
                                    <label aria-label="5 stars" class="rating__label" for="rating2-50"><i
                                            class="rating__icon rating__icon--star fa fa-star"></i></label>
                                    <input class="rating__input" name="rating2" id="rating2-50" value="5" type="radio">
                                </div>
                            </div>
                        </div>
                        <div>
                            <label class="form-label">Solve the Captcha<span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Captcha">
                            <div
                              *ngIf="feedbackForm.controls['name']?.invalid && feedbackForm.controls['name']?.touched"
                              class="text-danger">
                              Society Audit Start Date required.
                        </div>
                        </div>
                    </div> -->
                    <div class="col-lg-12 text-end">
                        <button type="button" class="btn btn-primary" [disabled]="feedbackForm.invalid"
                            (click)="addFeedback()">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    </div>